// @flow

import React from 'react';
import styled from 'styled-components';

import Logo from './Logo/Logo';
import SearchButton from './SearchButton/SearchButton';
import MainNav from './MainNav';

const Root = styled.div`
  flex-shrink: 0;

  position: relative;

  display: flex;
  justify-content: center;
  height: 46px;

  background-color: #3C3C3C;
  color: #FCFCFC;
`;

function Header() {
  return (
    <Root>
      <Logo />
      <MainNav />
      <SearchButton />
    </Root>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js